/** True when the request targets the USB/local token service on the user's machine. */
export function isLocalhostTokenServiceUrl(url: string): boolean {
  try {
    const host = new URL(url, window.location.origin).hostname;
    return host === 'localhost' || host === '127.0.0.1';
  } catch {
    return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(url);
  }
}
